module.exports = __webpack_public_path__ + "img/1019.be66a09e.gif";